var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLibraryBooks = function SvgLibraryBooks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#FFF",
    d: "M9.349 28.469v1.395h6.326v-1.395zm-8.418 0v1.395h4.837v-1.395zm29.018-.94-7.006 1.181.231 1.376 7.007-1.181zM26.393 6.362l-7.006 1.181.231 1.376 7.007-1.18zM.931 5.135V6.53h4.837V5.135zm26.109-.257 4.114 25.744L22.528 32 18.415 6.257zM0 2.605h6.697V32H0zm9.349-.136v1.395h6.326V2.469zM8.512 0h8v32h-8z",
    transform: "translate(.423)"
  })));
};
export { SvgLibraryBooks as ReactComponent };
export default __webpack_public_path__ + "assets/Library-Books.b89afd5af905c08c5f9307b45a71f6ee.svg";